import { computed, defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import FeedbackPopup from '@/components/FeedbackPopup/FeedbackPopup.vue'
import { useAuthStore } from '@/store/auth'
import { useMainStore } from '@/store/main'

export default defineComponent({
  name: 'AppNavigation',
  components: { FeedbackPopup },
  setup() {
    const isOpen = ref(false)
    const authStore = useAuthStore()
    const router = useRouter()
    const mainsStore = useMainStore()
    const menuList = computed(() => ([
      ...(authStore.user?.role === 'patient'
        ? [{
            title: 'Консультации',
            name: 'consultations',
          }]
        : []),
      {
        title: 'База знаний',
        name: 'base',
      },
      {
        title: 'Обратная связь',
        name: 'feedback',
      },
    ]))
    const logout = async () => {
      await authStore.logout()
      await router.push('/login')
    }
    const togglePopup = () => {
      isOpen.value = !isOpen.value
    }
    return { isOpen, mainsStore, logout, menuList, togglePopup }
  },
})
